import React from 'react'
import { Color } from '../../../Common/Color'
import BoxList from '../Common/BoxList'
import BoxMap from '../Common/BoxMap'
import BoxListHeader from '../Common/BoxListHeader'
import ComputerBoxCard from './ComputerBoxCard'

export default function ComputerBoxListPage ({ boxes, nearestBoxes, currentBox, setCurrentBox, lat, long, textList }) {
  return (
    <div style={{ gap: '1em', height: '100vh', display: 'flex', flexDirection: 'column', backgroundColor: Color.white }}>
      <BoxListHeader lat={lat} long={long} />
      <>
        <div className='body' style={{ flex: 1, gap: '1em', display: 'flex', flexDirection: 'horizontal', position: 'relative', overflow: 'auto' }}>
          <div style={{ overflow: 'auto' }}>
            <div style={{ textAlign: 'center', fontSize: '20px', fontWeight: 'bold', marginBottom: '1em' }}>{textList}</div>
            <BoxList currentBox={currentBox} setCurrentBox={setCurrentBox} boxes={nearestBoxes} BoxCard={ComputerBoxCard} />
          </div>
          <BoxMap currentBox={currentBox} setCurrentBox={setCurrentBox} boxes={boxes} lat={lat} long={long} BoxCard={ComputerBoxCard} />
        </div>
      </>
    </div>
  )
}
